import React, {useMemo} from 'react';
import {NavigationMenu, Provider, RoutePropagator} from '@shopify/app-bridge-react';
import {AppProvider, Frame, Spinner} from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';
import {Outlet, useLocation} from 'react-router-dom';
import {config_variable} from '../helper/commonApi';
import {useDispatch, useSelector} from 'react-redux';
import {generateToken} from '../redux/slice/commonSlice';
import HomePageComponent from '../pages/Dashboard/HomePageComponent';
import HelpGuidenceComponent from '../pages/HelpGuidence/HelpGuidenceComponent';
import LocalMenu from '../pages/LocalMenu';
import FaqComponent from "../pages/HelpGuidence/FaqComponent";

export function Router() {
    const {status} = useSelector(
        (store) => store.commonData
    );
    const location = useLocation();
    const dispatch = useDispatch();

    useMemo(async () => {
        await dispatch(generateToken()).unwrap();
    }, []);

    if (!config_variable.config.host) {
        config_variable.config.host = location?.state?.config?.host ? location?.state?.config?.host : config_variable.config.host;
        config_variable.shop_name = location?.state?.shop_name ? location?.state?.shop_name : config_variable.shop_name;
    }

    return (
        <>
            <div>
                <AppProvider i18n={enTranslations}>
                    {/* Use the App Bridge sidebar navigation whenever the app is
                        embedded (host + apiKey present) - works for both local and
                        production. Fall back to LocalMenu only when standalone. */}
                    {config_variable.config.host && config_variable.config.apiKey ?
                        !status ? <div style={{textAlign: "center", paddingTop: "20%"}}>
                                <Spinner accessibilityLabel="Spinner example" size="large"/>
                            </div> :
                            <Provider config={config_variable.config}>
                                <NavigationMenu
                                    navigationLinks={[
                                        {
                                            label: 'Contact support',
                                            destination: '/contact-support'
                                        },
                                        {
                                            label: 'FAQ',
                                            destination: '/faq'
                                        },
                                    ]}
                                    matcher={(link, location) =>  link.destination === location.pathname}/>
                                <Frame>
                                    <RoutePropagator location={location}/>
                                    <Outlet/>
                                </Frame>
                            </Provider> : <>
                            <LocalMenu/><Outlet/>
                        </>
                    }
                </AppProvider>
            </div>
        </>
    );
}

export const routes = [
    {path: '/', component: <HomePageComponent/>},
    {path: '/contact-support', component: <HelpGuidenceComponent/>},
    {path: '/faq', component: <FaqComponent/>},
];
